import * as Yup from "yup";

import {
  HouseContentsCalculatorFormValues,
  StandardOptions,
} from "./interfaces";

import { TextManager } from "Components/TextContext";

export const validationSchema =
  (): Yup.ObjectSchema<HouseContentsCalculatorFormValues> => {
    const { getText } = TextManager;

    return Yup.object({
      people: Yup.number()
        .min(1, ({ min }) =>
          getText("housecontentscalculator.validation.peopleminimum", {
            variables: { houseContentsCalculator_minimum_people: min },
            plurals: min === 1 ? "one" : "two",
          }),
        )
        .required(getText("housecontentscalculator.validation.people")),
      rooms: Yup.number()
        .min(1, ({ min }) =>
          getText("housecontentscalculator.validation.roomsminimum", {
            variables: { houseContentsCalculator_minimum_rooms: min },
          }),
        )
        .required(getText("housecontentscalculator.validation.rooms")),
      standard: Yup.mixed<StandardOptions>().required(
        getText("housecontentscalculator.validation.standard"),
      ),
      suggestedInsuranceAmount: Yup.number().optional(),
    }).defined();
  };
